module.exports = __webpack_public_path__ + "static/celltrackingapps-9d67abee46cbd524d95edc8121acbc92.svg";